import { Fragment } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/login/index.tsx";
import DashboardLayout from "../layouts/DashboardLayout.tsx";
import ProtectedRoute from "./ProtectedRoute.jsx";
import PagePlaceholder from "../pages/PagePlaceholder/index.tsx";
import NotFound from "../pages/NotFound/index.tsx";
import { useMenus } from "../config/menus.tsx";
import { getPageConfig } from "../config/pageRoutes.tsx";

function AppRoutes() {
  const { menus } = useMenus();

  const dashboardMenu = menus.find((menu) => menu.route === "/dashboard");

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route
          index
          element={<Navigate to={dashboardMenu ? "dashboard" : menus[0]?.route.replace(/^\//, "") || "."} replace />}
        />
        {menus.map((menu) => {
          const pagePath = menu.route.replace(/^\//, "");
          const config = getPageConfig(menu.route);

          if (!config) {
            return (
              <Route
                key={menu.id}
                path={pagePath}
                element={<PagePlaceholder menu={menu} />}
              />
            );
          }

          return (
            <Fragment key={menu.id}>
              <Route path={pagePath} element={<config.Component />} />
              {config.children?.map((child) => (
                <Route
                  key={child.path}
                  path={`${pagePath}/${child.path}`}
                  element={<child.Component />}
                />
              ))}
            </Fragment>
          );
        })}
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;